import { useState } from "react";
import { faqs, trendingTags } from "@/mocks/gua";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-12 md:py-16" aria-label="吃瓜常见问题">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <div className="lg:sticky lg:top-24">
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-secondary-700">
                <i className="ri-question-line" aria-hidden="true" />
                关于大瓜网
              </span>
              <h2 className="mt-1 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
                吃瓜常见问题
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                想了解如何参与讨论、内容如何把关、如何举报不友善内容？下面的回答能帮你更快上手。也欢迎随时通过页脚邮箱联系我们。
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                {trendingTags.slice(0, 6).map((t) => (
                  <a
                    key={t}
                    href="#hot"
                    className="whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    # {t}
                  </a>
                ))}
              </div>

              <div className="mt-6 rounded-2xl bg-primary-100/70 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-customer-service-2-line text-lg" aria-hidden="true" />
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">还有别的问题？</p>
                    <p className="text-xs text-foreground-600">欢迎反馈意见、举报不友善内容</p>
                  </div>
                </div>
                <a
                  href="mailto:hello@dagua.example.com"
                  className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-900 transition-colors hover:bg-background-100"
                >
                  <i className="ri-mail-send-line text-primary-600" aria-hidden="true" />
                  hello@dagua.example.com
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div
                    key={f.q}
                    className="overflow-hidden rounded-2xl border border-background-200 bg-background-100/60 transition-colors hover:border-background-300"
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIdx(open ? -1 : i)}
                        aria-expanded={open}
                        className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                      >
                        <span className="flex items-center gap-3 text-sm font-semibold text-foreground-900 md:text-base">
                          <span
                            className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                              open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-500"
                            }`}
                          >
                            {open ? <i className="ri-subtract-line" aria-hidden="true" /> : i + 1}
                          </span>
                          {f.q}
                        </span>
                        <i
                          className={`shrink-0 text-foreground-400 transition-transform ${open ? "rotate-45" : ""} ${
                            open ? "ri-subtract-line" : "ri-add-line"
                          }`}
                          aria-hidden="true"
                        />
                      </button>
                    </h3>
                    {open && (
                      <p className="border-t border-background-200 px-4 pb-4 pl-16 pt-3 text-sm leading-relaxed text-foreground-600 md:px-5">
                        {f.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}